exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editcipgrouppage-cssmodule-editcipgrouppage-component-3l3UC{border:1px dashed red;padding-top:15px;border:none}", ""]);

// exports
exports.locals = {
	"editcipgrouppage-component": "editcipgrouppage-cssmodule-editcipgrouppage-component-3l3UC"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/CipGroups/editcipgrouppage.cssmodule.scss
// module id = 601
// module chunks = 0